import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UsersListPage } from './UsersListPage';

const searchSchema = z.object({
  search: z.string().optional(),
  role: z.array(z.string()).optional(),
  status: z.array(z.string()).optional(),
  tags: z.array(z.string()).optional(),
  benefits: z.array(z.string()).optional(),
  loyaltyPrograms: z.array(z.string()).optional(),
  createdAfter: z.string().optional(),
  createdBefore: z.string().optional(),
  sortBy: z.enum(['created_at', 'updated_at', 'first_name', 'last_name', 'email']).optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
});

export const Route = createFileRoute('/_protected/admin/users/')({
  component: UsersListPage,
  validateSearch: searchSchema,
});
